let language = {
    "LBL_HOME":"Home",
    "LBL_USER": "Users",
    "LBL_USER_TYPE": "User Type",
    "LBL_VIEW_USER": "View Users",
    "LBL_ADD_USER": "Create Users",
    "LBL_FIRST_NAME":"First Name",
    "LBL_LAST_NAME":"Last Name",
    "LBL_USER_STATUS":"Status",
    "LBL_LOGIN_STATUS":"Login Status",
    "LBL_USER_NAME":"User Name",
    "LBL_USER_EMAIL":"User Email",
    "LBL_USER_PASSWORD":"Password",
    "LBL_CONFIRM_PASSWORD":"Confirm Password",
    "LBL_DEFAULT_EMAIL":"Email Options",
    "LBL_EMAIL":"Email",
    "LBL_EMAIL_CLIENT":"Email client",
    "LBL_EMAIL_ADDRESS":"Email Address",
    "LBL_USER_INFO":"User Information",
    "LBL_USER_DEPARTMENT":"Department",
    "LBL_USER_SEX":"Sex",
    "LBL_USER_GENDER":"Gender",
    "LBL_USER_MOBILE":"Mobile",
    "LBL_USER_QUALIFICATION":"Qualification",
    "LBL_USER_SPECIFICATION":"Specialization",
    "LBL_USER_ADDRESS_INFO":"Address Information",
    "LBL_PRIMARY_ADDRESS":"Primary Address",
    "LBL_ADDRESS_CITY":"City",
    "LBL_ADDRESS_STATE":"State",
    "LBL_ADDRESS_COUNTRY":"Country",
    "LBL_ADDRESS_POSTAL_CODE":"Postal Code",
    "LBL_USER_SETTING":"User Settings",
    "LBL_SYSTEM_ADMINISTRATOR":"System Administrator",
    "LBL_SHOW_FULLNAME":"Show Full Name",
    "LBL_LOCAL_SETTING":"Locale Settings",
    "LBL_DATE_FORMAT":"Date format",
    "LBL_TIME_FORMAT":"Time Format",
    "LBL_TIME_ZONE":"Time zone",
    "LBL_TIME_ZONEPROMPT":"Time zone prompt",
    "LBL_CURRENCY":"Currency",
    "LBL_CURRENCY_DIGIT":"Currency Significant Digits",
    "LBL_EXAMPLE":"Example",
    "LBL_SEPERATOR":"1000s separator",
    "LBL_DECIMAL_SYSBOL":"Decimal symbol",
    "LBL_DISPLAY_FORMAT":"Name Display Format",
    "LBL_BRANCH":"User Branch",
    "LBL_ROLE":"User Role",
    "LBL_PHONE":"Phone",
    "LBL_USER_PASSWORD":"User Password",
    "LBL_USER_IMAGE":"User Image",
    "LBL_DOWNLOAD_ONE":"Download 1",
    "LBL_DOWNLOAD_TWO":"Download 2",
    "LBL_CREATED_DATE":"Created Date",
    "LBL_ACTION_EDIT":"Edit",
    "LBL_ACTION_DELETE":"Delete",
    "LBL_SUPER_ADMINISTRATOR":"Super Admin",
    
}

export default language;